import ApplicationSerializer from 'lumen/serializers/application';

export default class ConfigSerializer extends ApplicationSerializer {
  modelNameFromPayloadKey(): string {
    return 'parity/config';
  }
}
